import { Component } from '@angular/core'
import { CongestionMapComponent } from '../components/maps/congestion-map'
import { CreditUsageChartComponent } from '../components/credit-usage-chart.component'
import { TripsGridComponent } from '../components/grids/trips-grid.component'
import { CrowdDataGridComponent } from '../components/grids/crowd-data-grid.component'
import { CreditAllowanceChartComponent } from '../components/credit-allowance-chart.component'

@Component({
  template: `
    <div class="h-full p-3 flex flex-col gap-3">
      <div class="flex-1 min-h-0 grid grid-cols-3 gap-3">
        <div class="min-h-0">
          @defer (on viewport; prefetch on idle) {
            <congestion-map />
          } @placeholder {
            <div
              class="h-full w-full rounded-lg bg-slate-800/50 animate-pulse"
            ></div>
          }
        </div>
        <div class="min-h-0">
          @defer (on viewport; prefetch on idle) {
            <credit-allowance-chart />
          } @placeholder {
            <div
              class="h-full w-full rounded-lg bg-slate-800/50 animate-pulse"
            ></div>
          }
        </div>
        <div class="min-h-0">
          @defer (on viewport; prefetch on idle) {
            <credit-usage-chart />
          } @placeholder {
            <div
              class="h-full w-full rounded-lg bg-slate-800/50 animate-pulse"
            ></div>
          }
        </div>
      </div>

      <div class="flex-1 min-h-0 grid grid-cols-2 gap-3">
        <div class="rounded-lg min-h-0">
          @defer (on viewport; prefetch on idle) {
            <crowd-data-grid />
          } @placeholder {
            <div
              class="h-full w-full rounded-lg bg-slate-800/50 animate-pulse"
            ></div>
          }
        </div>
        <div class="rounded-lg min-h-0">
          @defer (on viewport; prefetch on idle) {
            <trips-grid />
          } @placeholder {
            <div
              class="h-full w-full rounded-lg bg-slate-800/50 animate-pulse"
            ></div>
          }
        </div>
      </div>
    </div>
  `,
  imports: [
    TripsGridComponent,
    CongestionMapComponent,
    CreditUsageChartComponent,
    CrowdDataGridComponent,
    CreditAllowanceChartComponent,
  ],
})
export class DashboardPage {}
